import { render } from "./RestorePassword.vue?vue&type=template&id=46c99dfd"
import script from "./RestorePassword.vue?vue&type=script&lang=js"
export * from "./RestorePassword.vue?vue&type=script&lang=js"

import "./RestorePassword.vue?vue&type=style&index=0&id=46c99dfd&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__